import { useMutation } from "react-query";
import {
  NotificationDto,
  AddNotificationDto
} from "./plt-notifications-gateway.dtos";
import { HttpError } from "@bps/http-client";
import { useGateways } from "@libs/api/gateways-context";
import { useFeedbackContext } from "../../../stores/feedback-context/feedback-context";

export const useAddNotification = () => {
  const { pltNotificationsOpsGateway } = useGateways();
  const { success, error } = useFeedbackContext();
  return useMutation<NotificationDto, Error, AddNotificationDto>(
    pltNotificationsOpsGateway.addNotification,
    {
      onSuccess: () => {
        success("Notification successfully sent");
      },
      onError: () => {
        error("Error sending notification");
      }
    }
  );
};

export const useBatchAddNotification = () => {
  const { pltNotificationsOpsGateway } = useGateways();
  const { error, success } = useFeedbackContext();
  return useMutation<void, HttpError, AddNotificationDto[]>(
    pltNotificationsOpsGateway.batchAddNotification,
    {
      onSuccess: () => {
        success("Notifications successfully sent");
      },
      onError: () => {
        error("Error sending notifications");
      }
    }
  );
};
